module.exports = __webpack_public_path__ + "static/media/circle-plus-blinking.0f43a559.svg";